import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage, GetPickerCss, ExcludeSpecialCharactersFromInputTypeNumber } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";
import Select from '@material-ui/core/Select';
import moment from 'moment';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import { SketchPicker } from 'react-color';
import appFetch from '../../../../api/appFetch.js';
import { WorkshopPlanningIndicatorsUrl } from '../../../../constants/apiUrls.js';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';

export default class IndicatorsCreation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            outletId: props.selectedOutletId,
            outletName: "",
            description: "",
            dailyCapacity: "",
            isFixedTimeslot: false,
            isCompetence: false,
            isActive: false,
            color: "#FFFFFF",
            modifiedOn: "",
            modifiedByName: "",
            modifiedByAvatar: "",
            selectedOutletId: 0,
            loading: this.props.editedIndicatorId !== undefined,
            redirect: false,
            accessibleMoboOutlets: [],
            editedIndicatorId: this.props.editedIndicatorId,
            requestInProgress: false,
            open: true,
            indicatorWasCreated: false,
            displayColorPicker: false,
        };
    }

    componentDidMount() {
        var outlets = this.props.accessibleMoboOutlets.sort((a, b) => (a.description > b.description) ? 1 : -1)

        if (this.props.accessibleMoboOutlets === undefined) {
            return;
        }

        var outlet = outlets[0].id;

        if (this.props.outletId !== undefined) {
            this.setState({ outletId: this.props.outletId });
        }
        else {
            this.setState({ outletId: outlet });
        }
    }

    isValidForm = () => {
        const { description, dailyCapacity, color } = this.state;

        if (!description || description.trim().length === 0) {
            return false;
        }

        if (dailyCapacity && (parseInt(dailyCapacity) < 0 || parseInt(dailyCapacity) > 999)) {
            return false;
        }

        if (!color) {
            return false;
        }

        return true;
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/indicators" });
    };

    handleChange = e => {
        if (this.state.outletId === 0) {
            var outlets = this.props.accessibleMoboOutlets.sort((a, b) => (a.description > b.description) ? 1 : -1)
            this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, ""), outletId: outlets[0].id });
            return;
        }

        this.setState({ [e.target.name]: e.target.value });
    };

    handleChangeDailyCapacity = (e) => {
        if (isNaN(e.target.value) || parseInt(e.target.value) < 1 || parseInt(e.target.value) > 999) {
            return;
        }

        this.setState({ [e.target.name]: e.target.value });
    }

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleClickColorPicker = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleCloseColorPicker = () => {
        this.setState({ displayColorPicker: false })
    };

    handleChangeColorPicker = (color) => {
        this.setState({ color: color.hex })
    };

    handleChangeOutlet = e => {
        this.setState({ outletId: e.target.value });
    };

    handleSaveNewIndicator = () => {
        this.saveNewIndicator();
    }

    saveNewIndicator = () => {
        let resources = this.props.resources;
        if (this.state.description.trim().length <= 0) {
            DisplayMessage(resources["InvalidDescripton"], "error");
            return;
        }

        if (this.state.outletId <= 0) {
            DisplayMessage(resources["InvalidOutlet"], "error");
            return;
        }

        if (this.state.color.trim().length !== 7) {
            DisplayMessage(resources["InvalidColor"], "error");
            return;
        }

        let isDefaultDailyCapacity = false;

        if (this.state.dailyCapacity === "0" || this.state.dailyCapacity === "") isDefaultDailyCapacity = true;
        if (!isDefaultDailyCapacity && (parseInt(this.state.dailyCapacity) < 1 || parseInt(this.state.dailyCapacity) > 999)) {
            DisplayMessage(resources["InvalidDailyCapacity"], "error");
            return;
        }

        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            moboOutletId: this.state.outletId,
            description: this.state.description != "" ? this.state.description : null,
            id: this.state.id,
            colorHex: this.state.color.replace("#", ""),
            dailyCapacity: isDefaultDailyCapacity === true ? null : this.state.dailyCapacity,
            isCompetence: this.state.isCompetence,
            isActive: this.state.isActive,
            isFixedTimeslot: this.state.isFixedTimeslot,
        });

        const url = WorkshopPlanningIndicatorsUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: (data) => {
                DisplayMessage(resources["NewIndicatorWasSaved"], "success");
                this.setState({ indicatorWasCreated: true, redirect: "/indicators" });
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    renderModifiedByInfo = () => {
        let resources = this.props.resources;

        if (this.state.id > 0) {
            return (
              <ModifiedByInfo
                resources={resources}
                modifiedByAvatar={this.state.modifiedByAvatar}
                modifiedOn={this.state.modifiedOn}
                modifiedByName={this.state.modifiedByName}
                className="mt-3"
              />
            );
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleSaveNewIndicator();
    };

    renderForm() {
        const { isActive, isCompetence, isFixedTimeslot } = this.state;

        var resources = this.props.resources;
        var helperTextDescription =
            !this.state.description || this.state.description.trim().length === 0
                ? "helper-text-red"
                : "helper-text-grey";
        const styles = GetPickerCss(this.state.color);

        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form onSubmit={this.handleSubmit} >
                    <Form.Group className="pt-3" style={{ display: "flex" }}>
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={"col-6 " + helperTextDescription} id="indicators-description" defaultValue={this.state.description} label={resources["Description"]}
                                helperText={resources["InputOfDescriptionIsMandatory"]}
                                variant="outlined" name="description" onChange={this.handleChange} onKeyUp={this.handleKeyUp} inputProps={{ maxLength: 100 }} />
                        </ThemeProvider >
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-3"></div>
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={this.state.outletId}
                            onOutletChange={this.handleChangeOutlet}
                            containerClass="col-6"
                            noPlaceholder
                        />
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6" id="indicators-daily-capacity" defaultValue={this.state.dailyCapacity} value={this.state.dailyCapacity} label={resources["DailyCapacity"]} type="number" variant="outlined" name="dailyCapacity" onChange={this.handleChangeDailyCapacity} onKeyDown={ExcludeSpecialCharactersFromInputTypeNumber(true)} inputProps={{ min: 1, max: 999 }} />
                        </ThemeProvider >
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="indicators-is-active" checked={isActive} onChange={this.handleChangeCheckBox} name="isActive" color="primary" />}
                            label={resources["IsActive"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="indicators-is-competence" checked={isCompetence} onChange={this.handleChangeCheckBox} name="isCompetence" color="primary" />}
                            label={resources["IsCompetence"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3"> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="indicators-is-fixed-planning" checked={isFixedTimeslot} onChange={this.handleChangeCheckBox} name="isFixedTimeslot" color="primary" />}
                            label={resources["IsFixedPlanning"]} />

                        <div className="col-md-4"> </div>
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-md-3"></div>

                        <div>
                            <div style={{ display: "flex" }}>
                                <div style={styles.swatch} onClick={this.handleClickColorPicker}>
                                    <div style={styles.color} id="color-picker" />
                                </div>
                                <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1 align-center" style={{ paddingTop: "8px", paddingLeft: "3px" }} >{resources["ColorHex"]}
                                    <em className="text-danger">*</em></span>
                            </div>

                            {this.state.displayColorPicker ? <div style={styles.popover}>
                                <div style={styles.cover} onClick={this.handleCloseColorPicker} />
                                <SketchPicker color={this.state.color} onChange={this.handleChangeColorPicker} />
                            </div> : null}
                        </div>
                    </Form.Group>
                    {this.renderModifiedByInfo()}
                </Form>
            </Paper>
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
            {this.renderForm()}
        </div>;
    }

    render() {
        const { redirect, open, indicatorWasCreated, outletId, requestInProgress } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: indicatorWasCreated, outletId } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-add-indicator" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["AddNewIndicatorTitle"]}
                            </Typography>
                            <Button id="indicators-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}